import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-account-tab5',
  templateUrl: './my-account-tab5.component.html',
  styleUrls: ['./my-account-tab5.component.scss']
})
export class MyAccountTab5Component implements OnInit {
  MATitle = 'Cancel Zenplans'
  MACancelSub = {
    info: 'If you no longer want to continue your subscription to Zenplans then you can do so by clicking the button below.',
    warning: 'Please note that by ending your subscription, you and your delegates will no longer be able to access your plan.',
    modalCancel: 'Are you sure that you want calcel your subscription?'
  }
  constructor() { }

  ngOnInit() {
  }

}
